import datapoints from '../datapoints';
import filterItemsByIsReadValue from '../helpers/filterItemsByIsReadValue';
import * as suppressedItemIdsMapOperations from '../helpers/suppressedItemIdsMapOperations';
import markItemsAsReadService from '../services/markItemsAsReadService';
import { lazyAddMarkAsReadDiagnostics } from 'owa-group-readunread-diagnostics';
import markItemsAsReadStoreUpdate from 'owa-mail-actions/lib/triage/markItemsAsReadStoreUpdate';
import { getMailboxInfo } from 'owa-mail-mailboxinfo';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
import { userMailInteractionAction } from 'owa-mail-actions';
/**
 * Mark the specified conversations as read or unread based on the isReadValue
 * @param tableView the tableView containing the item being marked as read/unread
 * @param itemId the item id
 * @param isReadValue the isRead value to set
 * @param isExplicit whether the mark as read action is initiated explicitly by user
 */
export default action('markItemsAsReadBasedOnItemIds', datapoints.markItemReadUnreadDatapoint)(function markItemsAsReadBasedOnItemIds(tableView, itemIds, isReadValue, isExplicit, actionSource, instrumentationContexts) {
    var itemIdsToUpdate = filterItemsByIsReadValue(itemIds, isReadValue);
    if (itemIdsToUpdate.length == 0) {
        // Nothing to mark as read
        return;
    }
    if (isReadValue) {
        // If mark as read, always clear the suppressed state by removing item id
        suppressedItemIdsMapOperations.remove(itemIdsToUpdate);
    }
    else {
        if (isExplicit) {
            // If user explicitly mark item as unread, set the suppressed state by adding the item id.
            // The item doesn't necessarily needs to be selected. For example, when user marks unread on unselected expanded items, they should be
            // added to the suppression itemIds map, to keep them unread after user navigates away to another conversation.
            suppressedItemIdsMapOperations.add(itemIdsToUpdate);
        }
        else {
            trace.warn('Invalid scenario to implicitly mark item as unread.');
        }
    }
    // Tracking the mark as read operation for the diagnostics panel
    lazyAddMarkAsReadDiagnostics.import().then(function (addMarkAsReadDiagnostics) {
        addMarkAsReadDiagnostics(tableView.tableQuery, false /* isActingOnAllItemsInTable */, isReadValue, actionSource, itemIdsToUpdate);
    });
    // Dispatch action to update the store state
    markItemsAsReadStoreUpdate(itemIdsToUpdate, isReadValue);
    var requestOptions = getMailboxInfo(tableView).requestOptions;
    markItemsAsReadService(itemIdsToUpdate, isReadValue, requestOptions);
    if (isReadValue && isExplicit) {
        userMailInteractionAction('MarkAsRead', instrumentationContexts);
    }
    else if (!isReadValue) {
        userMailInteractionAction('MarkAsUnread', instrumentationContexts);
    }
});
//# sourceMappingURL=markItemsAsReadBasedOnItemIds.js.map